// extracted by mini-css-extract-plugin
export default {"about-us":"AboutUs_about-us__5QgC-","pos":"AboutUs_pos__B7Vqe","content":"AboutUs_content__DZyev","social":"AboutUs_social__Oxu4K"};